/**
 * Modern Product Card Interactions
 * Handles multi-view switching and quick view functionality
 */

class ModernProductCard {
  constructor(element) {
    this.element = element;
    this.imageWrapper = element.querySelector('.modern-product-card__image-wrapper');
    this.cardImage = element.querySelector('.modern-product-card__image');
    this.viewDots = element.querySelectorAll('.modern-product-card__view-dot');
    this.quickViewBtn = element.querySelector('.modern-product-card__quick-view-btn');
    
    this.init();
  }
  
  init() {
    // Multi-view switching
    if (this.viewDots.length > 0) {
      this.viewDots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.switchView(dot);
        });
      });
    }
    
    // Quick view (placeholder - can be expanded)
    if (this.quickViewBtn) {
      this.quickViewBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openQuickView();
      });
    }
  }
  
  switchView(activeDot) {
    const imageUrl = activeDot.dataset.imageUrl;
    
    if (!imageUrl || !this.cardImage) return;
    
    // Update active state
    this.viewDots.forEach(dot => dot.classList.remove('active'));
    activeDot.classList.add('active');
    
    // Fade out, change image, fade in
    this.cardImage.style.opacity = '0';
    
    setTimeout(() => {
      this.cardImage.src = imageUrl;
      this.cardImage.style.opacity = '1';
    }, 150);
  }
  
  openQuickView() {
    const productUrl = this.quickViewBtn.dataset.productUrl;
    console.log('Quick view for:', productUrl);
    // TODO: Implement quick view modal
    // For now, just navigate to product page
    window.location.href = productUrl;
  }
}

// Initialize all product cards
document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('.modern-product-card');
  productCards.forEach(card => new ModernProductCard(card));
});

// Re-initialize on dynamic content load (for AJAX cart, filters, etc.)
if (typeof Shopify !== 'undefined' && Shopify.theme) {
  document.addEventListener('shopify:section:load', () => {
    const productCards = document.querySelectorAll('.modern-product-card');
    productCards.forEach(card => new ModernProductCard(card));
  });
}
